import axios from 'axios';
import store from '../../store/index';
import { anonymizationOptions } from './constants/constants';

export default {
	list() {
		return axios.get(`/api/setup`);
	},
	save(settings) {
		return axios.patch(`/api/setup/`, settings);
	},
	getDatabaseExportUrl(models, anonymization) {
		let params = '';
		if (anonymization && anonymization.length > 0) {
			const allOptions = anonymizationOptions;
			const hasAllOptions = allOptions.every((option) => anonymization.includes(option)) && anonymization.every((option) => allOptions.includes(option));

			if (hasAllOptions) {
				params = '?anonymize=all';
			} else {
				params = `?anonymize=${anonymization.join(',')}`;
			}
		}
		return axios.post(`/api/dump${params}`, models);
	},
	uploadDump(data, name, chunkNumber) {
		return axios.patch(`/api/dump/`, { data, name, chunkNumber });
	},
	importDatabase(name, originalFilename) {
		return axios.post(`/api/dump/import`, { name, originalFilename });
	},
	redisCleanup() {
		return axios.post(`/api/redis/cleanup`, {});
	},
	getStatus() {
		return axios.get(`/api/status/`);
	},
	listModels() {
		return axios.get('/api/models/');
	},
	listUserGroups() {
		return axios.get('/api/user-groups/');
	},
	listDefaultLabels(ids) {
		return axios.get(`/api/labels?ids=${ids.join(',')}`);
	},
};
